import { useState } from "react";
import { signIn, signUp } from "../lib/auth.js";

export function AuthGate() {
  const [mode, setMode] = useState<"in" | "up">("in");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit() {
    setBusy(true);
    setError(null);
    const res =
      mode === "in"
        ? await signIn.email({ email, password })
        : await signUp.email({ email, password, name });
    setBusy(false);
    if (res.error) setError(res.error.message ?? "Failed");
    else window.location.href = "/compose";
  }

  return (
    <div className="center">
      <h2>{mode === "in" ? "Sign in" : "Create account"}</h2>
      {mode === "up" && (
        <>
          <label>Name</label>
          <input value={name} onChange={(e) => setName(e.target.value)} />
        </>
      )}
      <label>Email</label>
      <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
      <label>Password</label>
      <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
      {error && <p style={{ color: "crimson" }}>{error}</p>}
      <button style={{ marginTop: "1rem" }} disabled={busy} onClick={submit}>
        {mode === "in" ? "Sign in" : "Sign up"}
      </button>
      <p className="muted" style={{ marginTop: "1rem", cursor: "pointer" }} onClick={() => setMode(mode === "in" ? "up" : "in")}>
        {mode === "in" ? "Need an account? Sign up" : "Have an account? Sign in"}
      </p>
    </div>
  );
}
